// extracted by mini-css-extract-plugin
module.exports = {"root":"PhysCreatePromptModal_root__1-CD6","buttonGroup":"PhysCreatePromptModal_buttonGroup__2awcq"};